import { Radio, RadioGroup } from 'react-aria-components';
import styled, { css } from 'styled-components';
import { Box, BoxProps, boxStyle, FieldErrorText, StyledText } from '../atoms';
import { standardButtonStylesAcrossAllCompanies } from './Button';

const StyledRadio = styled(Radio)<{ $variant: 'selected' | 'unselected' }>`
    ${(props) => props.theme.toggleButton[props.$variant]}
    ${standardButtonStylesAcrossAllCompanies}

    ${(props) => {
        const variantStyles = props.theme.toggleButton[props.$variant];

        return css`
            ${variantStyles.default};

            &[data-focus-visible='true'] {
                ${variantStyles.focus};
            }

            &[data-focus='true'] {
                ${variantStyles.focus};
            }

            &:focus-visible {
                ${variantStyles.focus};
            }
            &:focus {
                ${variantStyles.focus};
            }
            &:hover {
                ${variantStyles.hover};
            }
            &:active {
                ${variantStyles.active};
            }
        `;
    }}
`;

const RadioGroupContainer = styled(RadioGroup)<BoxProps>`
    ${boxStyle}
`;

export function RadioButtons({
    radios,
    label,
    onChange,
    selected,
    errorMessage,
    isRequired,
    ...rest
}: BoxProps & {
    radios: Array<{ value: string; label: React.ReactNode; ariaLabel: string }>;
    label: string;
    errorMessage?: string;
    isRequired?: React.ComponentProps<typeof RadioGroup>['isRequired'];
    onChange: (s: string) => void;
    selected?: string | null;
}) {
    return (
        <RadioGroupContainer
            onChange={onChange}
            gap="8"
            direction="column"
            aria-errormessage={errorMessage}
            isRequired={isRequired}
            value={selected}
        >
            <StyledText variant="label" weight="bold">
                {label}
            </StyledText>
            <Box {...rest} gap="8">
                {radios.map((radio) => {
                    return (
                        <StyledRadio
                            aria-label={radio.ariaLabel}
                            key={radio.value}
                            value={radio.value}
                            $variant={
                                radio.value === selected
                                    ? 'selected'
                                    : 'unselected'
                            }
                        >
                            {radio.label}
                        </StyledRadio>
                    );
                })}
            </Box>
            <FieldErrorText>{errorMessage}</FieldErrorText>
        </RadioGroupContainer>
    );
}
